import React from "react";
import { Link } from "react-router-dom";

const BeforeFooter = () => {
    const handleClick = ()=>{
        const number = '09333800660'
        window.location.href = `tel:${number}`
    }
    const handleFollow = () => {
      // Assuming you have a direct link to your Instagram page
      const instagramPageLink = 'https://www.instagram.com/coffee_shadd/';
  
      // Open the Instagram page in a new tab or window
      const instagramWindow = window.open(instagramPageLink, '_blank');
  
      // Check if the window was successfully opened
      if (instagramWindow) {
        // Set up a timer to check if the user has followed you
        const checkFollowInterval = setInterval(() => {
          // Check if the user has followed you (you need to implement this part)
          const userFollowed = /* Your logic to check if the user followed you */ true;
  
          if (userFollowed) {
            // If the user has followed you, close the Instagram window and redirect back to your page
            instagramWindow.close();
            clearInterval(checkFollowInterval);
            window.location.href = 'https://www.menutest.sparrowagc.ir'; // Replace with your actual website URL
          }
        }, 1000); // Check every second (adjust the interval as needed)
      } else {
        // Handle the case where the window couldn't be opened
        alert('Please allow pop-ups to follow on Instagram.');
      }
    };
  return (
    <div className="sticky py-3 h-14 items-center bottom-0 flex justify-around  bg-gray-100 dark:bg-gray-700 w-full">
      <span onClick={handleFollow} className="flex justify-center items-center w-8 h-8 rounded-lg shadow ">
        {/* <a href="#"> */}
        {/* <a href="https://www.instagram.com/rez7bi/"> */}
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M27 0H5C2.23858 0 0 2.23858 0 5V27C0 29.7614 2.23858 32 5 32H27C29.7614 32 32 29.7614 32 27V5C32 2.23858 29.7614 0 27 0Z"
              fill="#F00073"
            />
            <path
              d="M16 9.2C18.2 9.2 18.5 9.2 19.4 9.2C20.2 9.2 20.6 9.4 20.9 9.5C21.3 9.7 21.6 9.8 21.9 10.1C22.2 10.4 22.4 10.7 22.5 11.1C22.6 11.4 22.7 11.8 22.8 12.6C22.8 13.5 22.8 13.7 22.8 16C22.8 18.3 22.8 18.5 22.8 19.4C22.8 20.2 22.6 20.6 22.5 20.9C22.3 21.3 22.2 21.6 21.9 21.9C21.6 22.2 21.3 22.4 20.9 22.5C20.6 22.6 20.2 22.7 19.4 22.8C18.5 22.8 18.3 22.8 16 22.8C13.7 22.8 13.5 22.8 12.6 22.8C11.8 22.8 11.4 22.6 11.1 22.5C10.7 22.3 10.4 22.2 10.1 21.9C9.8 21.6 9.6 21.3 9.5 20.9C9.4 20.6 9.3 20.2 9.2 19.4C9.2 18.5 9.2 18.3 9.2 16C9.2 13.7 9.2 13.5 9.2 12.6C9.2 11.8 9.4 11.4 9.5 11.1C9.7 10.7 9.8 10.4 10.1 10.1C10.4 9.8 10.7 9.6 11.1 9.5C11.4 9.4 11.8 9.3 12.6 9.2C13.5 9.2 13.8 9.2 16 9.2ZM16 7.7C13.7 7.7 13.5 7.7 12.6 7.7C11.7 7.7 11.1 7.9 10.6 8.1C10.1 8.3 9.6 8.6 9.1 9.1C8.6 9.6 8.4 10 8.1 10.6C7.9 11.1 7.8 11.7 7.7 12.6C7.7 13.5 7.7 13.8 7.7 16C7.7 18.3 7.7 18.5 7.7 19.4C7.7 20.3 7.9 20.9 8.1 21.4C8.3 21.9 8.6 22.4 9.1 22.9C9.6 23.4 10 23.6 10.6 23.9C11.1 24.1 11.7 24.2 12.6 24.3C13.5 24.3 13.8 24.3 16 24.3C18.2 24.3 18.5 24.3 19.4 24.3C20.3 24.3 20.9 24.1 21.4 23.9C21.9 23.7 22.4 23.4 22.9 22.9C23.4 22.4 23.6 22 23.9 21.4C24.1 20.9 24.2 20.3 24.3 19.4C24.3 18.5 24.3 18.2 24.3 16C24.3 13.8 24.3 13.5 24.3 12.6C24.3 11.7 24.1 11.1 23.9 10.6C23.7 10.1 23.4 9.6 22.9 9.1C22.4 8.6 22 8.4 21.4 8.1C20.9 7.9 20.3 7.8 19.4 7.7C18.5 7.7 18.3 7.7 16 7.7Z"
              fill="white"
            />
            <path
              d="M16 11.7C13.6 11.7 11.7 13.6 11.7 16C11.7 18.4 13.6 20.3 16 20.3C18.4 20.3 20.3 18.4 20.3 16C20.3 13.6 18.4 11.7 16 11.7ZM16 18.8C14.5 18.8 13.2 17.6 13.2 16C13.2 14.5 14.4 13.2 16 13.2C17.5 13.2 18.8 14.4 18.8 16C18.8 17.5 17.5 18.8 16 18.8Z"
              fill="white"
            />
            <path
              d="M20.4 12.6C20.9523 12.6 21.4 12.1523 21.4 11.6C21.4 11.0477 20.9523 10.6 20.4 10.6C19.8477 10.6 19.4 11.0477 19.4 11.6C19.4 12.1523 19.8477 12.6 20.4 12.6Z"
              fill="white"
            />
          </svg>
        {/* </a> */}
      </span>
      <span className="flex justify-center items-center w-8 h-8 rounded-lg shadow bg-teal-500 ">
        <a href="https://t.me/arashmehrabadi1996">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M27 0H5C2.23858 0 0 2.23858 0 5V27C0 29.7614 2.23858 32 5 32H27C29.7614 32 32 29.7614 32 27V5C32 2.23858 29.7614 0 27 0Z"
              fill="#0088CC"
            />
            <path
              d="M8.09992 15.7083C12.3949 13.8371 15.2589 12.6034 16.6919 12.0074C20.7834 10.3056 21.6335 10.01 22.1877 10.0001C22.3095 9.99805 22.582 10.0283 22.7586 10.1715C22.9076 10.2924 22.9486 10.4558 22.9683 10.5705C22.9879 10.6851 23.0123 10.9464 22.9929 11.1505C22.7712 13.4801 21.8118 19.1335 21.3237 21.7427C21.1172 22.8468 20.7105 23.217 20.3168 23.2532C19.4613 23.3319 18.8116 22.6878 17.9829 22.1446C16.6862 21.2946 15.9537 20.7654 14.695 19.936C13.2404 18.9774 14.1834 18.4506 15.0124 17.5896C15.2293 17.3643 18.999 13.9355 19.0719 13.6244C19.0811 13.5855 19.0895 13.4405 19.0034 13.3639C18.9172 13.2874 18.7901 13.3136 18.6983 13.3344C18.5683 13.3639 16.4968 14.7331 12.4839 17.4419C11.8959 17.8457 11.3633 18.0424 10.8862 18.0321C10.3601 18.0207 9.34822 17.7346 8.59598 17.4901C7.67333 17.1902 6.94002 17.0316 7.00388 16.5223C7.03714 16.257 7.40248 15.9856 8.09992 15.7083Z"
              fill="white"
            />
          </svg>
        </a>
      </span>
      <span className="flex justify-center items-center w-8 h-8 rounded-lg shadow dark:shadow-slate-500 ">
        <button onClick={handleClick}>
          <svg className="dark:invert"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M22.1844 2.66706H11.1489C9.43922 2.64291 8.03164 4.00529 8 5.71484V27.0637C8.03164 28.7733 9.43922 30.1357 11.1489 30.1115H22.1844C23.8941 30.1357 25.3017 28.7733 25.3333 27.0637V5.71484C25.3017 4.00529 23.8941 2.64291 22.1844 2.66706ZM14.8611 4.83373H18.4722V5.55595C18.4722 5.75539 18.3105 5.91706 18.1111 5.91706H15.2222C15.0228 5.91706 14.8611 5.75539 14.8611 5.55595V4.83373ZM22.1844 27.9448C22.6978 27.9695 23.1356 27.5768 23.1667 27.0637V5.71484C23.1356 5.2018 22.6978 4.80907 22.1844 4.83373H20.6389V5.55595C20.6389 6.22636 20.3726 6.86931 19.8985 7.34336C19.4245 7.81741 18.7815 8.08373 18.1111 8.08373H15.2222C13.8262 8.08373 12.6944 6.95201 12.6944 5.55595V4.83373H11.1489C10.6355 4.80907 10.1977 5.2018 10.1667 5.71484V27.0637C10.1977 27.5768 10.6355 27.9695 11.1489 27.9448H22.1844Z"
              fill="black"
            />
          </svg>
        </button>
      </span>
      <span className="flex justify-center items-center w-8 h-8 rounded-lg shadow dark:shadow-slate-500 ">
        <Link to='/location' >
        <svg className="dark:invert" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.6188 8.7C19.5788 4.07 15.5388 2 11.9988 2C11.9988 2 11.9988 2 11.9888 2C8.45877 2 4.42877 4.07 3.37877 8.69C2.19877 13.85 5.35877 18.22 8.21877 20.98C9.27877 22 10.6388 22.51 11.9988 22.51C13.3588 22.51 14.7188 22 15.7688 20.98C18.6288 18.22 21.7888 13.86 20.6188 8.7ZM14.7488 11.75H12.7488V13.75C12.7488 14.16 12.4088 14.5 11.9988 14.5C11.5888 14.5 11.2488 14.16 11.2488 13.75V11.75H9.24877C8.83877 11.75 8.49877 11.41 8.49877 11C8.49877 10.59 8.83877 10.25 9.24877 10.25H11.2488V8.25C11.2488 7.84 11.5888 7.5 11.9988 7.5C12.4088 7.5 12.7488 7.84 12.7488 8.25V10.25H14.7488C15.1588 10.25 15.4988 10.59 15.4988 11C15.4988 11.41 15.1588 11.75 14.7488 11.75Z" fill="#292D32"/>
</svg>


        </Link>
      </span>
    </div>
  );
};

export default BeforeFooter;
